import { ColumnDefinition } from '../../shared/components/table/models/column-definition.model';
import { PaginatedResponse } from '../../shared/components/table/models/page.model';

export const PRICE_LIST_COLUMNS: ColumnDefinition[] = [
  { field: 'effectiveDate', displayName: 'DATE', filter: true, sortable: true },
  { field: 'price', displayName: '({currency})' },
  { field: 'actions', displayName: 'ACTIONS' }
];
export const TRANSACTION_LIST_COLUMNS: ColumnDefinition[] = [
  {
    field: 'transactionNumber',
    displayName: 'TRANSACTION_LIST_COLUMNS.TRANSACTION_NUMBER',
    sortable: true,
    width: '14rem'
  },
  {
    field: 'transactionDate',
    displayName: 'TRANSACTION_LIST_COLUMNS.TRANSACTION_DATE',
    sortable: true,
    filter: true,
    width: '16rem'
  },
  {
    field: 'plantationName',
    displayName: 'TRANSACTION_LIST_COLUMNS.PLANTATION_NAME',
    sortable: true,
    filter: true,
    width: '16rem'
  },
  {
    field: 'plantationCode',
    displayName: 'TRANSACTION_LIST_COLUMNS.PLANTATION_CODE',
    sortable: true,
    width: '16rem'
  },
  { field: 'eudrCompliant', displayName: 'TRANSACTION_LIST_COLUMNS.COMPLIANCE_RATING', filter: true, width: '17rem' },
  { field: 'buyer', displayName: 'TRANSACTION_LIST_COLUMNS.BUYER', filter: true, width: '10rem' },
  { field: 'factoryCode', displayName: 'TRANSACTION_LIST_COLUMNS.FACTORY_CODE', filter: true, width: '12rem' },
  { field: 'seller', displayName: 'TRANSACTION_LIST_COLUMNS.SELLER', filter: true, width: '10rem' },
  { field: 'role', displayName: 'TRANSACTION_LIST_COLUMNS.ROLE', sortable: true, filter: true, width: '11rem' },
  { field: 'status', displayName: 'TRANSACTION_LIST_COLUMNS.STATUS', sortable: true, filter: true, width: '10rem' },
  { field: 'volume', displayName: 'TRANSACTION_LIST_COLUMNS.VOLUME_KG', sortable: true, filter: true, width: '13rem' },
  {
    field: 'country',
    displayName: 'TRANSACTION_LIST_COLUMNS.COUNTRY',
    filter: true,
    width: '10rem'
  },
  {
    field: 'adm1',
    displayName: 'TRANSACTION_LIST_COLUMNS.PROVINCE_STATE',
    filter: true,
    width: '16rem'
  },
  {
    field: 'adm2',
    displayName: 'TRANSACTION_LIST_COLUMNS.DISTRICT',
    filter: true,
    width: '12rem'
  },
  {
    field: 'adm3',
    displayName: 'TRANSACTION_LIST_COLUMNS.SUBDISTRICT',
    filter: true,
    width: '11rem'
  },
  {
    field: 'adm4',
    displayName: 'TRANSACTION_LIST_COLUMNS.VILLAGE',
    filter: true,
    width: '11rem'
  },
  {
    field: 'collectionPointName',
    displayName: 'TRANSACTION_LIST_COLUMNS.COLLECTION_POINT',
    sortable: true,
    filter: true,
    width: '14rem'
  },
  { field: 'actions', displayName: 'ACTIONS', width: '8rem' }
];

export const MULTI_TIER_TRANSACTION_COLUMNS: ColumnDefinition[] = [
  { field: 'transactionNumber', displayName: 'MULTI_TIER_LIST_COLUMNS.TRANSACTION_NO', sortable: true, width: '15rem' },
  {
    field: 'transactionDate',
    displayName: 'MULTI_TIER_LIST_COLUMNS.TRANSACTION_DATE',
    sortable: true,
    filter: true,
    width: '16rem'
  },
  { field: 'buyer', displayName: 'MULTI_TIER_LIST_COLUMNS.BUYER', filter: true, width: '12rem' },
  { field: 'seller', displayName: 'MULTI_TIER_LIST_COLUMNS.SELLER', filter: true, width: '12rem' },
  { field: 'eudrCompliant', displayName: 'MULTI_TIER_LIST_COLUMNS.COMPLIANCE', filter: true, width: '14rem' },
  { field: 'status', displayName: 'MULTI_TIER_LIST_COLUMNS.STATUS', sortable: true, filter: true, width: '12rem' },
  { field: 'volume', displayName: 'MULTI_TIER_LIST_COLUMNS.VOLUME_KG', sortable: true, filter: true, width: '13rem' },
  { field: 'adm1', displayName: 'MULTI_TIER_LIST_COLUMNS.PROVINCE', filter: true, width: '14rem' },
  { field: 'adm2', displayName: 'MULTI_TIER_LIST_COLUMNS.DISTRICT', filter: true, width: '12rem' },
  {
    field: 'collectionPointName',
    displayName: 'MULTI_TIER_LIST_COLUMNS.COLLECTION_POINT',
    sortable: true,
    filter: true,
    width: '14rem'
  },
  { field: 'download', displayName: 'MULTI_TIER_LIST_COLUMNS.ACTION', width: '8rem' }
];

export const PREVIOUS_TRANSACTION_COLUMNS: ColumnDefinition[] = [
  { field: 'transactionNumber', displayName: 'MULTI_TIER_LIST_COLUMNS.TRANSACTION_NO', sortable: true, width: '15rem' },
  { field: 'acceptedDate', displayName: 'MULTI_TIER_LIST_COLUMNS.TRANSACTION_DATE', sortable: true, width: '16rem' },
  { field: 'parent', displayName: 'MULTI_TIER_LIST_COLUMNS.PARENT', width: '12rem' },
  { field: 'tier', displayName: 'MULTI_TIER_LIST_COLUMNS.TIER', sortable: true, filter: true, width: '8rem' },
  { field: 'eudrCompliant', displayName: 'MULTI_TIER_LIST_COLUMNS.COMPLIANCE', filter: true, width: '14rem' },
  { field: 'buyerName', displayName: 'MULTI_TIER_LIST_COLUMNS.BUYER', filter: true, width: '12rem' },
  { field: 'sellerName', displayName: 'MULTI_TIER_LIST_COLUMNS.SELLER', filter: true, width: '12rem' },
  { field: 'volume', displayName: 'MULTI_TIER_LIST_COLUMNS.VOLUME_KG', sortable: true, width: '13rem' },
  { field: 'adm1', displayName: 'MULTI_TIER_LIST_COLUMNS.PROVINCE', width: '14rem' },
  { field: 'adm2', displayName: 'MULTI_TIER_LIST_COLUMNS.DISTRICT', width: '12rem' },
  { field: 'collectionPointName', displayName: 'MULTI_TIER_LIST_COLUMNS.COLLECTION_POINT', filter: true, width: '15rem' }
];

export const PLANTATION_DETAIL_COLUMNS: ColumnDefinition[] = [
  { field: 'plantationName', displayName: 'TRANSACTION_LIST_COLUMNS.PLANTATION', sortable: true, width: '15rem' },
  {
    field: 'eudrCompliant',
    displayName: 'MULTI_TIER_LIST_COLUMNS.COMPLIANCE',
    sortable: true,
    filter: true,
    width: '16rem'
  },
  { field: 'sellerName', displayName: 'TRANSACTION_LIST_COLUMNS.FARMER', sortable: true, filter: true, width: '12rem' },
  { field: 'volume', displayName: 'MULTI_TIER_LIST_COLUMNS.VOLUME_KG', sortable: true, width: '13rem' },
  { field: 'adm1', displayName: 'TRANSACTION_LIST_COLUMNS.PROVINCE_STATE', sortable: true, filter: true, width: '14rem' },
  { field: 'adm2', displayName: 'TRANSACTION_LIST_COLUMNS.DISTRICT', sortable: true, filter: true, width: '12rem' },
  { field: 'adm3', displayName: 'TRANSACTION_LIST_COLUMNS.SUB_DISTRICT', sortable: true, filter: true, width: '12rem' },
  { field: 'adm4', displayName: 'TRANSACTION_LIST_COLUMNS.VILLAGE', sortable: true, filter: true, width: '12rem' },
  {
    field: 'collectionPointName',
    displayName: 'TRANSACTION_LIST_COLUMNS.COLLECTION_POINT',
    sortable: true,
    filter: true,
    width: '15rem'
  }
];

export const INITIAL_PAGINATED_RESPONSE: <T>() => PaginatedResponse<T> = <T>() => ({
  count: 0,
  page: 1,
  num_pages: 0,
  pageSize: 10,
  results: [] as T[]
});
